import AddIcon from '@material-ui/icons/Add';
import RemoveCircleOutline from '@material-ui/icons/RemoveCircleOutline';
import React, { useCallback } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { Text } from '../../../../core-ui';
import { DocumentProblemType } from '../../../../generated/globalTypes';
import { VerificationRequests } from '../../../../generated/VerificationRequests';
import { colors } from '../../constants/theme';
import {
  nextAction as nextActionType,
  ownerDataUnverifiedProblem,
  ownerNameUnverifiedProblem,
  unverifiedDocumentType,
  unverifiedIdProblem,
  unverifiedSelfieProblem,
} from '../../constants/unverifiedDocument';

import Dropdown from './Dropdown';
type Options = {
  label: string;
  value: DocumentProblemType;
};
export type UnverifiedReasonData = Omit<
  NonNullable<
    VerificationRequests['requestVerificationAdvance']['row'][0]['unverifiedReasonData']
  >[0],
  '__typename'
>;

type Props = {
  setUnverifiedReasonData: (value: Array<UnverifiedReasonData>) => void;
  unverifiedReasonData: Array<UnverifiedReasonData>;
  disabledDocumentType?: boolean;
  disabledProblem?: boolean;
  disabled?: boolean;
};

const UnverifiedCategories = (props: Props) => {
  let {
    setUnverifiedReasonData,
    unverifiedReasonData,
    disabledDocumentType,
    disabledProblem,
    disabled,
  } = props;

  let onChangeData = useCallback(
    (newData: Partial<UnverifiedReasonData>, index: number) => {
      const next = [...unverifiedReasonData];
      next[index] = { ...next[index], ...newData };
      setUnverifiedReasonData(next);
    },
    [setUnverifiedReasonData, unverifiedReasonData],
  );

  return (
    <>
      {unverifiedReasonData.map(
        ({ documentProblemType, nextAction, problemReason }, index) => {
          return (
            <>
              <View
                style={index !== 0 ? styles.container : styles.firstContainer}
              >
                <Dropdown
                  onChange={(value: DocumentProblemType) => {
                    onChangeData(
                      {
                        documentProblemType: value,
                        nextAction: '',
                        problemReason: '',
                      },
                      index,
                    );
                  }}
                  label={t(['Jenis Dokumen', 'Document Type'])}
                  value={documentProblemType}
                  options={unverifiedDocumentType as Array<Options>}
                  disabled={disabled || disabledDocumentType}
                  disableOption={
                    index !== 0
                      ? {
                          disable: true,
                          nameOption: unverifiedReasonData.map(
                            ({ documentProblemType }) =>
                              documentProblemType || '',
                          ),
                        }
                      : undefined
                  }
                  containerStyle={styles.documentDropdownContainer}
                />
                <Dropdown
                  onChange={(value: string) => {
                    let nextActionDesc = nextActionType.find(
                      (val) => val.problem === value,
                    );
                    onChangeData(
                      {
                        nextAction: nextActionDesc?.action || '',
                        problemReason: value,
                      },
                      index,
                    );
                  }}
                  label={t(['Permasalahan yang Ditemukan', 'Problem Found'])}
                  value={problemReason}
                  options={
                    documentProblemType === 'KTP'
                      ? unverifiedIdProblem
                      : documentProblemType === 'SELFIE'
                      ? unverifiedSelfieProblem
                      : documentProblemType === 'DATA'
                      ? ownerDataUnverifiedProblem
                      : ownerNameUnverifiedProblem
                  }
                  disabled={disabled || disabledProblem || !documentProblemType}
                  containerStyle={styles.problemDropdownContainer}
                />
                {index !== 0 && (
                  <TouchableOpacity
                    style={styles.deleteDropdownIcon}
                    onPress={() => {
                      setUnverifiedReasonData(
                        unverifiedReasonData.filter((_, i) => i !== index),
                      );
                    }}
                    disabled={disabled}
                  >
                    <RemoveCircleOutline htmlColor={colors.text.red} />
                  </TouchableOpacity>
                )}
              </View>
              <Text style={styles.nextActionText}>
                Next Action : {nextAction}
              </Text>
              <View style={styles.divider} />
            </>
          );
        },
      )}
      {unverifiedReasonData.length !== 3 && (
        <TouchableOpacity
          style={styles.addCategoriesContainer}
          onPress={() => {
            setUnverifiedReasonData([
              ...unverifiedReasonData,
              {
                documentProblemType: null,
                nextAction: '',
                otherReason: '',
                phoneCategory: null,
                problemReason: '',
                storePhotoCategory: null,
              },
            ]);
          }}
          disabled={disabled}
        >
          <AddIcon htmlColor={disabled ? colors.text.grey : colors.icon.blue} />
          <Text
            color={disabled ? 'disabled' : 'link'}
            style={styles.addCategoryText}
          >
            Tambah Kategori
          </Text>
        </TouchableOpacity>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginTop: 16,
  },
  firstContainer: {
    flexDirection: 'row',
  },
  documentDropdownContainer: { maxWidth: 108, flex: 1, marginRight: 12 },
  problemDropdownContainer: { marginRight: 12, flex: 1, maxWidth: 316 },
  deleteDropdownIcon: {
    justifyContent: 'center',
    marginTop: 21,
    marginLeft: 3,
  },
  nextActionText: { marginTop: 8 },
  divider: {
    width: '100%',
    borderColor: colors.button.border.primary,
    borderWidth: 1,
    borderStyle: 'solid',
    marginTop: 16,
  },
  addCategoriesContainer: {
    marginTop: 17,
    flexDirection: 'row',
  },
  addCategoryText: {
    marginLeft: 8,
    alignSelf: 'center',
    fontWeight: '900',
  },
});

export default UnverifiedCategories;
